import { SignIn, SignedIn, SignedOut } from '@clerk/clerk-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Shell } from './components/Shell.js';
import Activity from './routes/Activity.js';
import AlarmDetail from './routes/AlarmDetail.js';
import AlarmReport from './routes/AlarmReport.js';
import AlarmsList from './routes/AlarmsList.js';
import Broadcasts from './routes/Broadcasts.js';
import CheckInReport from './routes/CheckInReport.js';
import CheckIns from './routes/CheckIns.js';
import Dashboard from './routes/Dashboard.js';
import IncidentDetail from './routes/IncidentDetail.js';
import Incidents from './routes/Incidents.js';
import Journeys from './routes/Journeys.js';
import LiveMap from './routes/LiveMap.js';
import OffShiftVisitsReport from './routes/OffShiftVisitsReport.js';
import ReimbursementReport from './routes/ReimbursementReport.js';
// Renamed from Roster to Users in Phase 2 of the team-leader rollout. Old
// /roster URLs redirect to /users via the Route element below.
import Users from './routes/Roster.js';
import Settings from './routes/Settings.js';
import Sites, { SiteDetailPage } from './routes/Sites.js';
import Teams, { TeamDetailPage } from './routes/Teams.js';
import TravelReport from './routes/TravelReport.js';
import UtilisationReport from './routes/UtilisationReport.js';
import Visits from './routes/Visits.js';
import { NotFound } from './routes/stubs.js';

export default function App() {
  return (
    <>
      <SignedOut>
        <SignInShell />
      </SignedOut>

      <SignedIn>
        <Routes>
          <Route path="/" element={<Shell />}>
            <Route index element={<Dashboard />} />
            <Route path="alarms" element={<AlarmsList />} />
            <Route path="alarms/:id" element={<AlarmDetail />} />
            <Route path="check-ins" element={<CheckIns />} />
            <Route path="visits" element={<Visits />} />
            <Route path="map" element={<LiveMap />} />
            <Route path="journeys" element={<Journeys />} />
            <Route path="users" element={<Users />} />
            {/* Backwards-compat redirect for the old /roster URL. */}
            <Route path="roster" element={<Navigate to="/users" replace />} />
            <Route path="teams" element={<Teams />} />
            <Route path="teams/:id" element={<TeamDetailPage />} />
            <Route path="sites" element={<Sites />} />
            <Route path="sites/:id" element={<SiteDetailPage />} />
            <Route path="activity" element={<Activity />} />
            <Route path="incidents" element={<Incidents />} />
            <Route path="incidents/:id" element={<IncidentDetail />} />
            <Route path="broadcasts" element={<Broadcasts />} />
            <Route path="reports/travel" element={<TravelReport />} />
            <Route path="reports/reimbursement" element={<ReimbursementReport />} />
            <Route path="reports/check-ins" element={<CheckInReport />} />
            <Route path="reports/alarms" element={<AlarmReport />} />
            <Route path="reports/utilisation" element={<UtilisationReport />} />
            <Route path="reports/off-shift-visits" element={<OffShiftVisitsReport />} />
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </SignedIn>
    </>
  );
}

function SignInShell() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[radial-gradient(ellipse_at_top,_#2a1d5e_0%,_#1e1645_40%,_#140e35_100%)] p-6">
      <div className="text-center">
        <div className="mb-1 font-heading text-3xl font-extrabold tracking-tight text-brand-light-blue">
          empower
        </div>
        <div className="mb-7 font-body text-sm text-white/70">Safety Dashboard</div>
        <SignIn
          routing="hash"
          signUpUrl="/#/sign-up"
          fallbackRedirectUrl="/"
          signUpFallbackRedirectUrl="/"
        />
      </div>
    </div>
  );
}
